import { render, staticRenderFns } from "./questionnairetopic.vue?vue&type=template&id=d7ff1166&"
import script from "./questionnairetopic.vue?vue&type=script&lang=js&"
export * from "./questionnairetopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports